/**
 * Presentational primitives for the trainer dashboard — the replacement for
 * react-bootstrap's Card / Button / Badge / Alert / Spinner / ListGroup.
 *
 * These render plain elements and carry their own look in primitives.css,
 * so the screen no longer depends on Bootstrap's `.card` / `.btn` / `.badge`
 * base rules coming in from style.css.
 */

// Styles live in the single TrainerDashboard.css, imported by the page.

const cx = (...parts) => parts.filter(Boolean).join(' ');

export const Card = ({ className, children, ...rest }) => (
  <div className={cx('td-card', className)} {...rest}>{children}</div>
);
export const CardHeader = ({ className, children, ...rest }) => (
  <div className={cx('td-card-head', className)} {...rest}>{children}</div>
);
export const CardBody = ({ className, children, ...rest }) => (
  <div className={cx('td-card-body', className)} {...rest}>{children}</div>
);

/** variant maps to a tone class; `link` renders as a borderless text button. */
export const Button = ({ variant = 'primary', size, className, type = 'button', children, ...rest }) => (
  <button
    type={type}
    className={cx('td-btn', `td-btn--${variant}`, size && `td-btn--${size}`, className)}
    {...rest}
  >
    {children}
  </button>
);

export const Badge = ({ bg = 'secondary', className, children, ...rest }) => (
  <span className={cx('td-badge', `td-badge--${bg}`, className)} {...rest}>{children}</span>
);

export const Alert = ({ variant = 'info', className, children, ...rest }) => (
  <div role="alert" className={cx('td-alert', `td-alert--${variant}`, className)} {...rest}>
    {children}
  </div>
);
export const AlertHeading = ({ className, children, ...rest }) => (
  <h4 className={cx('td-alert-head', className)} {...rest}>{children}</h4>
);

/** `variant` is accepted and ignored — it only ever selected a spinner shape. */
export const Spinner = ({ variant, className, ...rest }) => (
  <span
    className={cx('td-spinner', variant && `td-spinner--${variant}`, className)}
    role="status"
    aria-label="Loading"
    {...rest}
  />
);

export const List = ({ variant, className, children, ...rest }) => (
  <div className={cx('td-list', variant === 'flush' && 'td-list--flush', className)} {...rest}>
    {children}
  </div>
);
export const ListItem = ({ className, children, ...rest }) => (
  <div className={cx('td-list-item', className)} {...rest}>{children}</div>
);
